var styles = {"overlay":"bc-exercise-states__overlay","wrapper":"bc-exercise-states__wrapper","icon":"bc-exercise-states__icon","message":"bc-exercise-states__message","buttons":"bc-exercise-states__buttons","percentage":"bc-exercise-states__percentage"};

export { styles as default };
